// src/components/Layout/Header.jsx
import React from 'react';
import { useDispatch } from 'react-redux';
import { openCreateModal } from '../../store/slices/tasksSlice.js';
import { useTheme } from '../../hooks/useTheme.jsx';

export default function Header() {
  const dispatch = useDispatch();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="app-header">
      <div className="logo">
        <div className="logo-icon">⊞</div>
        TaskFlow
      </div>
      <div className="header-actions">
        <button 
          className="btn btn-icon" 
          onClick={toggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
        <button className="btn btn-primary" onClick={() => dispatch(openCreateModal())}>
          + New Task
        </button>
      </div>
    </header>
  );
}
